import ADD_LINE_ITEMS_DIALOG_SETTINGS from './AddLineItemDialog/LOCAL_STORAGE_KEY';

// Every localStorage key this app writes. Anything not listed here belongs to someone else on the same origin,
// so clearing app data on log out or user change must never touch it (no localStorage.clear()).
export const LOCAL_STORAGE_KEYS = {
  // The token is no longer used (the session is a cookie); kept so a stale one is removed on log out
  LEGACY_TOKEN: 'token',
  LOCALE: 'locale',
  IS_AUTO_CALCULATE: 'isAutoCalculate',
  ADD_LINE_ITEMS_DIALOG_SETTINGS,
};

export const clearAppLocalStorage = () => {
  Object.values(LOCAL_STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
};
